import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout from "@/components/layout/Layout";
import ROICalculator from "@/components/sections/ROICalculator";

export default function ROIPage() {
  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="roi-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">ROI Calculator</span>
          <h1 className="heading-massive mt-4">
            See the savings <br /><span className="text-tratou-green">in real numbers.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-tratou-dim text-lg">
            Adjust your power profile, duration and fuel cost. We'll compute your diesel spend, CO₂
            avoided and total savings — calibrated against real Tratou EaaS pricing.
          </p>
        </div>
      </section>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <ROICalculator embedded />
      </div>

      <section className="py-20 text-center" data-testid="roi-cta">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="heading-section">Like what you see?</h2>
          <p className="mt-4 text-tratou-dim">
            Get a binding proposal calibrated to your exact site profile within 24 hours.
          </p>
          <Link to="/contact?intent=quote" className="btn-primary mt-8" data-testid="roi-cta-quote">
            Request a Detailed Proposal <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
